// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__nJIcT","additionalInfo":"AgreementModal_additionalInfo__3n8rb"};